import React, { useEffect, useState } from 'react';
import { Pane, SelectField, majorScale, toaster, FormField } from 'evergreen-ui';
import { CustomCheckbox, SelectGoogleOrgUnitInput } from '../../../../../../components/inputs';
import accounts from '../../../../../../constants/accounts';
import { api } from '../../../../../../services/api';

const AccountsStep = (formik) => {
  const [loading, setLoading] = useState(true);
  const [enabledAccounts, setEnabledAccounts] = useState([]);

  useEffect(async () => {
    try {
      const { data } = await api.settings.get('onboarding_ticket');
      setEnabledAccounts(data.accounts);
      setLoading(false);
    } catch (error) {
      toaster.error('Error occured while loading enabled accounts. Please try again later');
      setEnabledAccounts(['google', 'snipe']);
      setLoading(false);
    }
  }, []);

  return {
    title: 'Accounts',
    description: 'If you only want to create the Google account, skip this step',
    body: !loading && (
      <Pane>
        {accounts.filter((account) => enabledAccounts.includes(account.key)).map((account) => {
          return (
            <React.Fragment key={account.key}>
              <CustomCheckbox
                name={`accounts.${account.key}`}
                label={account.name}
                disabled={!account.editable}
                onCheck={formik.handleChange}
                defaultValue={formik.values.accounts && formik.values.accounts[account.key]}
              />
              {account.key === 'google' && formik.values.accounts && formik.values.accounts.google && (
                <FormField
                  label="Organizational unit"
                  marginTop={majorScale(2)}
                  maxWidth="50%"
                  validationMessage={formik.errors.google_org_unit}>
                  <SelectGoogleOrgUnitInput
                    value={formik.values.google_org_unit}
                    onChange={(selected) => formik.setFieldValue('google_org_unit', selected)} />
                </FormField>
              )}
            </React.Fragment>
          );
        })}
      </Pane>
    ),
  };
};

export default AccountsStep;
